// export const IMG_LOGIN_BG = "https://d113ddgi4j6d7k.cloudfront.net/dashboard/auth_bg.png";
export const IMG_LOGIN_BG = require('./auth_bg.png');
export const IMG_ERROR = require('./error.png');
export const IMG_GRAPH = require('./graph.png');
export const IMG_EMPTY = require('./empty.png');
export const IMG_EMPTY_MSG = require('./empty_msg.png');
export const IMG_USER = require('./user.png');
export const IMG_USER_TYPING = require('./typing_user.png');


export const IMG_MESSENGER = require('./messenger.svg');
export const IMG_CHAT_INTERFACE = require('./chat_interface.jpg');

export const IMG_CHATTING = require('./chatting.png');
export const IMG_PERSON = require('./person.png');

export const IMG_SAD = require('./sad.png');




// WEBPACK FOOTER //
// ./src/data/assets/img/index.js